import { Environment } from './environment.model';
import { APP_VERSION } from './version';

export const environment: Environment = {
  environment: 'dev',
  appVersion: APP_VERSION,
  amplitude: { apiKey: '3000dd0f17ddf94a733911e2d29e43fc' },
  production: false,
  oktaClientId: '0oas1sanekp6u1uUo697',
  apiEndpoints: {
    'api-mobile': 'https://api-internal.dev.insidebrightside.com',
    copilot: 'https://copilot.dev.insidebrightside.com/api/v1',
  },
  sentry: {
    dsn: 'https://9afb809b96d96ce273e52f7997dc6a0a@o4505166779187200.ingest.us.sentry.io/4509713674272768',
    environment: 'dev',
  },
  // Deployed dev target; StoryService resolves to local override when app hostname is localhost/127.0.0.1.
  storyServiceBaseUrl: 'https://story.dev.insidebrightside.com',
  storyServiceLocalBaseUrl: 'http://localhost:3000',
  storyDemoKey: 'a-random-demo-key-here',
  storyAdminKey: 'a-random-admin-key-here',
};
